var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuoteStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 6.30859V0.308594C30 0.308594 18 0.308593 18 12.3086V24.3086H30V12.3086H24C24 12.3086 24 6.3086 30 6.3086V6.30859ZM0 12.3086V24.3086H12V12.3086H6C6 12.3086 6 6.30859 12 6.30859V0.308594C12 0.308594 0 0.308593 0 12.3086V12.3086Z",
    fill: "#005DA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuoteStart);
export default __webpack_public_path__ + "static/media/Icon-quote-start.f96d324ac0a6010d17dc03543dd6ac3f.svg";
export { ForwardRef as ReactComponent };